import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GlobalModalWindowComponent } from '../../shared/components/global-modal-window/global-modal-window.component';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';
import { GoogleAnalyticsService } from './google-tag-manager.service';
import { SpoeSimpleErrorDialogComponent } from '../../shared/components/spoe-simple-error-dialog/spoe-simple-error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class GlobalModalWindowService {
  isProd: boolean = null;
  constructor(private matDialog: MatDialog,
    private preInitSettingsService: PreInitSettingsService,
    private resourceService: ADPResourceService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private ngZone: NgZone
  ) {
    this.isProd = this.preInitSettingsService.getSettings()?.isProduction?.toLowerCase() == 'true';
  }

  displayErrorModal(statusCode: string, error: any) {
    this.isProd = this.preInitSettingsService.getSettings()?.isProduction?.toLowerCase() == 'true';

    let content = this.getErrorContent(statusCode, error);
    this.showModalWindow(error, content);
  }

  displaySimpleErrorModal(messageSfKey: string, headerSfKey?: string) {
    headerSfKey = headerSfKey ?? 'Global_Modal_Error_Header_Desc';

    const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.height = 'auto';
      dialogConfig.data = {
        headerKey: headerSfKey,
        titleKey: messageSfKey,
        isProd: this.isProd,
        buttonTextKey: 'Global_Button_Close',
      };

      this.googleAnalyticsService.emitErrorEvent(this.resourceService.getViewLabel(messageSfKey), 'BadRequest', '400');

      this.matDialog.open(GlobalModalWindowComponent, dialogConfig);
  }

  getErrorContent(statusCode: string, error: any): string {
    let messageUsingErrorCode = this.resourceService.getLabel(`Global_Error_Code_` + error.ErrorCode);
    if (messageUsingErrorCode) {
      return messageUsingErrorCode;
    }

    let message = this.resourceService.getLabel(`Global_Error_Code_ec${statusCode}`);
    let defaultMessage = this.resourceService.getLabel('Global_Error_Code_Default');

    if (message && message.length) {
      return message;
    } else if (defaultMessage && defaultMessage.length) {
      return defaultMessage;
    } else {
      return 'Oops! An error occurred. The application has encountered an unexpected error.'
    }
  }

  showModalWindowMin(titleKey: string, source: string, contentKey: string = undefined) {
    this.isProd = this.preInitSettingsService.getSettings()?.isProduction?.toLowerCase() == 'true';

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = 'global-error-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      headerKey: 'Global_Modal_Error_Header_Desc',
      titleKey: titleKey ?? 'Global_Modal_Error_Title', // This property will get shown to the End User in Production
      contentKey: contentKey ?? 'Global_Modal_Error_Content', // This property will get shown to the End User in Production
      source: source ?? 'Unknown',
      isProd: this.isProd,
      buttonTextKey: 'Global_Button_Close'
    };

    if (titleKey) {
      this.googleAnalyticsService.emitErrorEvent(this.resourceService.getViewLabel(titleKey), source, '400');
    }

    this.ngZone.run(() => {
      this.matDialog.open(GlobalModalWindowComponent, dialogConfig);
    });
  }

  private showModalWindow(error: any, content: string) {
    if (error) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.id = 'global-error-dialog';
      dialogConfig.height = 'auto';

      dialogConfig.data = {
        headerKey: 'Global_Modal_Error_Header_Desc',
        title: content, // This property will get shown to the End User in Production
        errorMessage: error.Message,
        errorId: error.ErrorId, // This property will get shown to the End User in Production
        source: error.Source ?? 'Unknown',
        errorCode: error.ErrorCode ?? 'Unknown',
        isProd: this.isProd,
        buttonTextKey: 'Global_Button_Close'
      };

      this.ngZone.run(() => {
        this.matDialog.open(GlobalModalWindowComponent, dialogConfig);
      });
    }
  }

  private tryParseJson(jsonString: string) {
    try {
      return JSON.parse(jsonString) ?? {};
    } catch {
      return {};
    }
  }


  openSPOESimpleErrorDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'spoe-simple-error-dialog';
    const dialogRef = this.matDialog.open(SpoeSimpleErrorDialogComponent, dialogConfig);
  }

}
